import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { Icon } from '@elements';
import close from '@images/delete.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * ModalTitleSlot component.
 *
 * @author Mikhail Siutsou
 * @function ModalTitle
 * @category components
 * @param {ModalFooterProps} content props.
 * @return {JSX.Element} ModalTitleSlot component.
 */
var ModalTitle = function ModalTitle(_ref) {
  var children = _ref.children,
      handleClose = _ref.handleClose,
      adminModal = _ref.adminModal;
  var titleContent = typeof children === 'string' ? /*#__PURE__*/_jsx(Typography, {
    variant: "h4",
    component: "p",
    fontWeight: "bold",
    textAlign: "center",
    children: children
  }) : children;
  return /*#__PURE__*/_jsxs(Grid, {
    container: true,
    spacing: 2,
    flexWrap: "nowrap",
    alignItems: "flex-start",
    justifyContent: "space-between",
    position: "relative",
    children: [/*#__PURE__*/_jsx(Grid, {
      item: true,
      xs: 12,
      children: titleContent
    }), !adminModal && /*#__PURE__*/_jsx(Grid, {
      item: true,
      position: "absolute",
      right: "-1%",
      top: "-36%",
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: handleClose,
        size: "small",
        children: /*#__PURE__*/_jsx(Icon, {
          src: close,
          width: 24,
          height: 24,
          color: "comet"
        })
      })
    })]
  });
};

ModalTitle.displayName = 'ModalTitle';
export { ModalTitle };